export default __webpack_public_path__ + "static/media/stomach1.bb8fbb12.jpg";